module.exports = __webpack_public_path__ + "static/media/hcl_logo.70a00716.png";